export class DateParserModel {
  constructor(public target = '', public targetColumn = '', public format = '', public timeZone = 'UTC') {}
}
